import createFormatNumber from './create-format-number';

const I18N_NESTING_KEY_SEPARATOR = '$';

export default function createI18nConfig() {
  return {
    keySeparator: I18N_NESTING_KEY_SEPARATOR,
    interpolation: {
      escapeValue: false,
      format: (value, format, lng = 'en') => {
        switch (format) {
          case 'uppercase':
            return value.toUpperCase();
          case 'number':
            return createFormatNumber(lng)(value);
          default:
            return value;
        }
      },
    },
  };
}
